import React from "react";

export default function Circle(props: any){
	let children = props?.children;
	let backgroundColor = props?.frameProps?.backgroundColor;
	let fill = backgroundColor || 'none';
	const viewBoxSize = 1000
	
	return <>
		<svg xmlns="http://www.w3.org/2000/svg" width={viewBoxSize} height={viewBoxSize} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
			<defs>
				<clipPath id="squareView">
					<rect {...{width: viewBoxSize, height: viewBoxSize }}/>
				</clipPath>
			</defs>
			<g clipPath="url(#squareView)">
				<rect {...{width: viewBoxSize, height: viewBoxSize, fill }}/>
				{children}
			</g>
		</svg>
	</>
}